// Debug logging utility
// Set to true to enable console logging for development/debugging
const DEBUG = false;

export const debug = {
  log: (...args: unknown[]) => {
    if (DEBUG) console.log("TRP:", ...args);
  },
  warn: (...args: unknown[]) => {
    if (DEBUG) console.warn("TRP:", ...args);
  },
  error: (...args: unknown[]) => {
    // Always log errors, but can be disabled if needed
    if (DEBUG) console.error("TRP:", ...args);
  },
};

export default debug;
